import { objectToQueryString, downloadFile } from "../api";

export const downloadClientSummary = async (isDisabled, filters = {}) => {
  const queryString = objectToQueryString(filters);
  const url = `export/clientSummary?isdisabled=${isDisabled}${queryString ? '&' + queryString : ''}`;
  let response = await downloadFile(url, {});
  return response;
}
export const downloadServiceLookup = async () => {
  const url = 'export/ServiceNameIdLookup';
  let response = await downloadFile(url, {});
  return response;
}
export const downloadProgramLookup = async () => {
  const url = 'export/ProgramNameIdLookup';
  let response = await downloadFile(url, {});
  return response;
}

export const downloadStaffData = async () => {
  const url = 'export/StaffWithRoles';
  let response = await downloadFile(url, {});
  return response;
}

export const downloadClientAssignmentData = async () => {
  const url = 'export/ClientStaffAssignments';
  let response = await downloadFile(url, {});
  return response;
}


